import { AuthCallbackComponent } from './auth-callback.component';
import { NgModule } from "@angular/core";
import { PoModule } from "@po-ui/ng-components";
import { PoPageLoginModule } from "@po-ui/ng-templates";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [AuthCallbackComponent],
    exports:[AuthCallbackComponent],
    imports:[
        CommonModule,
        PoModule,
        PoPageLoginModule,
        FormsModule
    ]
})
export class AuthCallbackModule {


}
